export function canShowApplePay() {
    if (typeof window === "undefined") return false
  
    // 1. ApplePaySession ต้องมี
    if (!window.ApplePaySession) return false
  
    // 2. ต้องเป็น HTTPS
    if (window.location.protocol !== "https:") return false
  
    // 3. เช็กว่า device จ่าย Apple Pay ได้จริง
    try {
      return window.ApplePaySession.canMakePayments()
    } catch {
      return false
    }
}